import React from 'react'
import { TermsFooterProps } from './TermsFooter'

export interface LinkContext {
    links: TermsFooterProps
}

export const LinkContext = React.createContext<LinkContext>({
    links: { footerTermsLinks: [] },
})
